import React from "react";
import { IPersonaProps } from "office-ui-fabric-react";
import PersonPickerInput, { IPersonaPropsWithOrigin, PersonInfo, Props } from "./PersonPickerInput";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ResourcesListStore from "../../../store/ResourcesListStore";
import { ResourceLoadingTypes } from "../../../store/ResourcesListStore";
import { IUserInfo } from "../../../entities/common";
import { HUNDRED_PCT } from "../../utils/common";

type ActionProps = {
    resourcesActions: typeof ResourcesListStore.actionCreators;
}

// US 15956: chip label "Name (units%)". The label only — `text` stays the name, so the coin keeps its initials.
// A null/absent Units is the 100% default (as TaskAssignments.tsx and server GetUnitsFactor read it).
export const renderAssigneePrimaryText = (persona?: IPersonaProps): JSX.Element => {
    // origin is the underlying assignee (an IUserInfo carrying Units) — PersonInfo doesn't declare Units.
    const info = (persona as IPersonaPropsWithOrigin | undefined)?.origin as unknown as IUserInfo | undefined;
    const name = info?.fullName ?? persona?.text ?? '';
    return <span>{info == null ? name : `${name} (${info.units ?? HUNDRED_PCT}%)`}</span>;
};

const AssigneePickerInput = (props: Props & ActionProps) => {
    const { multichoice, itemProps } = props;

    const func = (value: PersonInfo | PersonInfo[] | null, callback?: (value: PersonInfo | PersonInfo[] | null) => any) => {
        const ids = !value
            ? []
            : multichoice
                ? (value as PersonInfo[]).map(v => v.id)
                : [(value as PersonInfo).id];
        if(ids.length > 0) {
            props.resourcesActions.loadResourcesByIds(ids, ResourceLoadingTypes.Calendar, undefined, true, () => callback?.(value));
        }
        else {
            callback?.(value);
        }
    };

    return <PersonPickerInput {...props}
        itemProps={{ onRenderPrimaryText: renderAssigneePrimaryText, ...itemProps }}
        onEditComplete={(value) => func(value, props.onEditComplete)}
        onChanged={(value) => func(value, props.onChanged)}/>;
}


function mergeActionCreators(dispatch: any): ActionProps {
    return {
        resourcesActions : bindActionCreators(ResourcesListStore.actionCreators, dispatch)
    }
}

export default connect(undefined, mergeActionCreators)(AssigneePickerInput);
